/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlLookup } from "@anvilor/ngx-rui";
import { RuiCompositeControlLookup } from "@anvilor/ngx-rui";
import { CONTROL_SUBMIT_BUTTON } from "./submit-button-control/submit-button-control";
import { SubmitButtonControlComponent } from "./submit-button-control/submit-button-control.component";
import { CONTROL_FORM_LAYOUT } from "./form-layout-control/form-layout-control";
import { FormLayoutControlComponent } from "./form-layout-control/form-layout-control.component";
import { CONTROL_SURVEY_STATES } from "./survey-states-control/survey-states-control";
import { SurveyStatesControlComponent } from "./survey-states-control/survey-states-control.component";
import { CONTROL_STANDARD_SURVEY_LAYOUT } from "./standard-survey-layout-control/standard-survey-layout-control";
import { StandardSurveyLayoutControl } from "./standard-survey-layout-control/standard-survey-layout-control";
import { CONTROL_SUBMIT_BUTTON_PANEL } from "./submit-button-panel-control/submit-button-panel.control";
import { SubmitButtonPanelControl } from "./submit-button-panel-control/submit-button-panel.control";
import { CONTROL_ATTENTION_BANNER } from "./attention-banner-control/attention-banner-control";
import { AttentionBannerControlComponent } from "./attention-banner-control/attention-banner-control.component";
import { CONTROL_RECAPTCHA_CHALLENGE } from "./recaptcha-challenge-control/recaptcha-challenge-control";
import { RecaptchaChallengeControlComponent } from "./recaptcha-challenge-control/recaptcha-challenge-control.component";

export const SURVEY_RUI_CONTROLS: ControlLookup = {
  [CONTROL_SUBMIT_BUTTON]: SubmitButtonControlComponent,
  [CONTROL_FORM_LAYOUT]: FormLayoutControlComponent,
  [CONTROL_SURVEY_STATES]: SurveyStatesControlComponent,
  [CONTROL_ATTENTION_BANNER]: AttentionBannerControlComponent,
  [CONTROL_RECAPTCHA_CHALLENGE]: RecaptchaChallengeControlComponent,
};

export const SURVEY_RUI_COMPOSITE_CONTROLS: RuiCompositeControlLookup = {
  [CONTROL_STANDARD_SURVEY_LAYOUT]: (store, id) =>
    new StandardSurveyLayoutControl(store, id),
  [CONTROL_SUBMIT_BUTTON_PANEL]: (store, id) => new SubmitButtonPanelControl(store, id),
};
